import React, {useEffect, useState} from 'react';
import AnalyzeHeader from './AnalyzeHeader';
import AnalyzeBody from './AnalyzeBody';
import { useDispatch, useSelector } from 'react-redux';
import { getAnalyzeInfo } from '../../actions/AnalyzeActions'
import useWindowDimentions from '../hooks/useWindowDimentions'

const AnalyzeComponent = ({currentTime, analyzeRef, videoInfoExpanded}) => {

    let time = 0

    const dispatch = useDispatch()

    const [activeData, setActiveData] = useState({})
    const [resultLink, setResultLink] = useState("")
    const [activeHeader, setActiveHeader] = useState(0)
    const [analyzeGenre, setAnalyzeGenre] = useState()
    const [analyzeMood, setAnalyzeMood] = useState()

    const { width } = useWindowDimentions()
    const isMobile = width < 992

    const { watermark_info, footprint_info } = useSelector(state=>state.analyze_info)

    const { activeVideo } = useSelector(state => state.activeVideo)

    useEffect(()=>{

         if(activeVideo && currentTime!==0){
            if (activeVideo.duration-30<currentTime){
                time = Math.floor((activeVideo.duration-30)/5)*5
            } else {
                time = Math.floor(currentTime/5)*5
            }
            dispatch(getAnalyzeInfo(activeVideo.id, currentTime, time))
        }
    },[currentTime])

    useEffect(()=>{
        setAnalyzeGenre()
        setAnalyzeMood()
        if (watermark_info && watermark_info.wm_track){
            setActiveData(watermark_info.wm_track);
            setResultLink(watermark_info.result_link)
            if(watermark_info.wm_track.genre_title){
                setAnalyzeGenre(watermark_info.wm_track.genre_title)
            }
            setActiveHeader(1)
        } else if (footprint_info && footprint_info.fp_track){
            setActiveData(footprint_info.fp_track);
            setResultLink(footprint_info.result_link)
            if(footprint_info.fp_track.fp && footprint_info.fp_track.fp.mood) {
                setAnalyzeMood(footprint_info.fp_track.fp.mood)
            }
            setActiveHeader(2)
        }

    },[watermark_info, footprint_info])

    useEffect(()=>{
        setActiveData()
    },[activeVideo])

    return (
        <>
            {
                activeData && (!isMobile || videoInfoExpanded) &&
                <div className = "w-100 px-lg-5 py-1 py-lg-5 bg-bluedark d-flex justify-content-center" ref={analyzeRef}>
                    <div className='col-12 col-lg-11 bg-primary rounded px-2 px-md-5 py-1 py-md-5'>
                            <>
                                <AnalyzeHeader
                                    setActiveData = {setActiveData}
                                    setResultLink = {setResultLink}
                                    activeHeader={activeHeader}
                                    setActiveHeader={setActiveHeader}
                                    setAnalyzeGenre = {setAnalyzeGenre}
                                    setAnalyzeMood = {setAnalyzeMood}
                                />
                                <AnalyzeBody
                                    activeData = {activeData}
                                    resultLink = {resultLink}
                                    analyzeGenre = {analyzeGenre}
                                    analyzeMood = {analyzeMood}
                                />
                            </>
                    </div>
                </div>
            }
        </>
    );
}

export default AnalyzeComponent;